const MAX_DECODE_PASSES = 5;

// Compare on the segment a downstream consumer would actually see. A NUL byte
// truncates the name for C-backed readers, and Windows drops trailing blanks,
// so an "exe" segment padded with either must still match the configured list.
function normalizeSegment(segment) {
  // eslint-disable-next-line no-control-regex
  return String(segment || "").replace(/[\u0000-\u001F\u007F]/g, "").trim();
}

export function validateUploadFileName(fileName, config = {}) {
  if (!fileName || typeof fileName !== "string" || fileName.trim().length === 0) {
    return { isValid: false, error: "Filename cannot be empty." };
  }

  const cleanFileName = fileName.trim();
  const blockedInnerExtensions = Array.isArray(config.blocked_inner_extensions)
    ? config.blocked_inner_extensions
    : String(config.blocked_inner_extensions || "").split(",");
  const blockedSet = new Set(blockedInnerExtensions
    .map((extension) => String(extension || "").trim().toLowerCase())
    .filter(Boolean)
    .map((extension) => extension.startsWith(".") ? extension : `.${extension}`));

  let decodedFileName = cleanFileName;
  for (let attempt = 0; attempt < MAX_DECODE_PASSES; attempt += 1) {
    try {
      const next = decodeURIComponent(decodedFileName);
      if (next === decodedFileName) break;
      decodedFileName = next;
    } catch (_error) {
      break;
    }
  }

  const nameParts = decodedFileName.replace(/\\/g, "/").split("/").pop().toLowerCase().split(".");
  const blockedInnerExtension = nameParts
    .slice(1, -1)
    .map(normalizeSegment)
    .find((part) => part && blockedSet.has(`.${part}`));
  if (blockedInnerExtension) {
    return { isValid: false, error: `Filename contains restricted inner extension .${blockedInnerExtension}.` };
  }

  const allowedCharsPattern = config.submissionfile_allowed_chars;
  if (!allowedCharsPattern) return { isValid: true, error: null };

  const allowedPattern = new RegExp(allowedCharsPattern);
  if (!allowedPattern.test(cleanFileName)) {
    return { isValid: false, error: `Filename "${cleanFileName}" contains invalid characters. Only letters, numbers, dots, underscores, dashes, spaces, and brackets are allowed.` };
  }
  return { isValid: true, error: null };
}
